import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form } from 'react-bootstrap';
import './Navbar.css';
import './Preloader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faPaperPlane,
  faMapMarkerAlt,
  faPhone,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';

import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';

import logo from '../assets/images/logo.png';
import mail from '../assets/images/mail.png';
import location from '../assets/images/location.png';
import phone from '../assets/images/phone-call.png';


const Navbar = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 12);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    document.body.style.overflow = sidebarOpen ? 'auto' : 'hidden';
  };

  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  return (
    <>
      <header>
        <div
          id="header-sticky"
          className={`header-area header-transparent header-pad header-border ${isSticky ? 'sticky' : ''
            }`}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-2 col-6">
                <div className="logo logo-border">
                  <Link to="/">
                    <img className="logo-white" src={logo} alt="logo" />
                  </Link>
                </div>
              </div>

              <div className="col-xl-8 col-lg-8 d-none d-lg-block">
                <div className="main-menu" style={{ textAlign: 'right' }}>
                  <nav id="mobile-menu">
                    <ul>
                      <li><Link to="/" className="active">Home</Link></li>
                      <li><Link to="/Aboutus">About Us</Link></li>
                      <li><Link to="/Listing">Listings</Link></li>
                      <li><Link to="/Landowners">Land Owners</Link></li>
                      <li><Link to="/Blog">Blogs</Link></li>
                      <li><Link to="/FAQs">FAQs</Link></li>
                      <li className="d-lg-none"><Link to="/ContactUs"> Buy Verified Plot</Link></li>
                    </ul>
                  </nav>
                </div>
              </div>

              <div className="col-xl-2 col-lg-2 col-6">
                <div className="header-right-info d-flex align-items-center justify-content-end">

                  {/* Contact Us button - 2nd last */}
                  <div className="header-btn d-none d-lg-block ">
                    <Link to="/ContactUs" className="tp-btn contactBtn">
                      Buy Verified Plot                    </Link>
                  </div>

                  {/* Sidebar toggle - last */}
                  <div className="sidebar__menu" style={{ marginLeft: '30px' }}>
                    <div
                      className="sidebar-toggle-btn ml-30"
                      id="sidebar-toggle"
                      onClick={toggleSidebar}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className="line"></span>
                      <span className="line"></span>
                      <span className="line"></span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </header>


      {/* Sidebar */}
      <div
        className={`sidebar__area ${sidebarOpen ? 'sidebar-opened' : ''}`}
      >
        <div className="sidebar__wrapper">
          <div className="sidebar__close">
            <button
              className="sidebar__close-btn"
              id="sidebar__close-btn"
              onClick={toggleSidebar}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div className="sidebar__content">
            {/* Logo */}
            <div className="logo mb-40">
              <Link to="/" onClick={toggleSidebar}>
                {/* <img src={logo} alt="logo" /> */}
                <button className='tp-btn1 signUpBtn'>Sign Up</button>
              </Link>
              <p style={{marginTop:'15px' ,fontSize: '15px', color: '#706f6d' }}>Skip the legal maze of land buying. Our verified plots come with pre-checked documents and expert approval.</p>
            </div>

            {/* Menu */}
            <div className="mobile-menu fix">
              <ul>
                <li>
                  <Link to="/" onClick={toggleSidebar}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/Aboutus" onClick={toggleSidebar}>
                    ABOUT US
                  </Link>
                </li>
                <li>
                  <Link to="/Listing" onClick={toggleSidebar}>
                    LISTINGS
                  </Link>
                </li>
                <li>
                  <Link to="/Landowners" onClick={toggleSidebar}>
                  LAND OWNERS
                  </Link>
                </li>
                <li>
                  <Link to="/Blog" onClick={toggleSidebar}>
                  BLOG
                  </Link>
                </li>
                <li>
                  <Link to="/FAQs" onClick={toggleSidebar}>
                  FAQs
                  </Link>
                </li>
                <li>
                  <Link to="/ContactUs" onClick={toggleSidebar}>
                    CONTACT US
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="sidebar__contact mb-45 mt-40">
              <h4 className='getInTouch'>Get In Touch</h4>
              <hr />
              <ul>
                {/* Address */}
                <Row className="align-items-start contact-row">
                  <Col xs={2} sm={2} className="mb-2 mb-sm-0">
                    <img
                      src={location}
                      alt="Location"
                      width={35}
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </Col>
                  <Col xs={10} sm={10}>
                    <span style={{ fontSize: '15px', lineHeight: '1.4', color: '#706f6d' }}>
                      WeWork Krishe Emerald, Kondapur Main Road, Kondapur, Laxmi Cyber City, Whitefields, Hyderabad, Telangana 500084
                    </span>
                  </Col>
                </Row>

                {/* Phone */}
                <Row className="align-items-start mt-4 contact-row">
                  <Col xs={2} sm={2} className="mb-2 mb-sm-0">
                    <img
                      src={phone}
                      alt="Phone"
                      width={30}
                      style={{ maxWidth: '80%', height: 'auto' }}
                    />
                  </Col>
                  <Col xs={10} sm={10}>
                    <span style={{ fontSize: '15px', lineHeight: '1.4', color: '#706f6d' }}>
                      +91 9908173249 <br />
                      +91 9963700363
                    </span>
                  </Col>
                </Row>

                {/* Email */}
                <Row className="align-items-start mt-4 contact-row">
                  <Col xs={2} sm={2} className="mb-2 mb-sm-0">
                    <img
                      src={mail}
                      alt="Mail"
                      width={30}
                      style={{ maxWidth: '80%', height: 'auto' }}
                    />
                  </Col>
                  <Col xs={10} sm={10}>
                    <span style={{ fontSize: '15px', lineHeight: '1.4', color: '#706f6d' }}>
                      contact@plotsverified.com
                    </span>
                  </Col>
                </Row>


              </ul>
            </div>
            <div className="sidebar__subscribe mt-40">
              <h4 className="subscribeTitle">Subscribe Now</h4>
              <hr />

              {/* Email Input */}
              <div className="subscribe-box d-flex align-items-center">
                <input
                  style={{ border: 'none' }}
                  type="email"
                  placeholder="Your Email Address"
                  className="form-control subscribe-input"
                />
                <button className="subscribe-btn">
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </div>

              {/* Social Icons */}



              <div className="social-icons mt-3">
                <a href="https://www.facebook.com/profile.php?id=61578760829709">
                  <FontAwesomeIcon icon={faFacebook} /> 
                </a>
                <a href="#">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a href="https://www.youtube.com/channel/UC807vZ90skqmHUcHTjr_w3w">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a href="https://www.instagram.com/plotsverified/">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Overlay */}
      <div
        className={`body-overlay transition-3 ${sidebarOpen || searchOpen ? 'opened' : ''
          }`}
        onClick={() => {
          if (sidebarOpen) toggleSidebar();
          if (searchOpen) toggleSearch();
        }}
      ></div>
    </>
  );
};

export default Navbar;
